import { store } from '@/store'

const updateDocumentTitle = ():void => {
    //  Get tenant
    const tenant = store.getters.tenant

    //  If the tenant does NOT exist, return default app name
    if (!tenant) return (document.title = process.env.VUE_APP_NAME)

    //  Get the Tenant title
    let tenantTitle = tenant.company_name ? tenant.company_name.toUpperCase() : tenant.subdomain.toUpperCase()

    //  Grab our bucket groups count
    const unreadMessages = store.getters.defaultBucketUnreadCount

    //  If unread messages, add new messages text to title
    if (unreadMessages > 0) tenantTitle += ` - ${unreadMessages} new message(s)`

    //  Set document title
    document.title = tenantTitle
}

export default {
    onApplicationLoaded() {
        store.getters.appDebug && console.log('DocumentTitle: onApplicationLoaded')
        updateDocumentTitle()
    },
    onBucketsPushed() {
        store.getters.appDebug && console.log('DocumentTitle: onBucketsPushed')
        updateDocumentTitle()
    },
    onChannelsPushed() {
        store.getters.appDebug && console.log('DocumentTitle: onChannelsPushed')
        updateDocumentTitle()
    },
    onMessageReceived() {
        store.getters.appDebug && console.log('DocumentTitle: onMessageReceived')
        updateDocumentTitle()
    },
    onTenantSet() {
        store.getters.appDebug && console.log('DocumentTitle: onTenantSet')
        updateDocumentTitle()
    },
    onTenantRemoved() {
        store.getters.appDebug && console.log('DocumentTitle: onTenantRemoved')
        updateDocumentTitle()
    }
}